import React, { memo } from 'react';
import {useState} from 'react';
import { Handle } from 'react-flow-renderer';

import speaker from '../img/speaker.png'

export default memo(({ data }) => {

    
    var style = {
        background:'gold',
        color:'purple',
        textAlign:'center',
        width:50,
        height:50
    
    } 


    return (
    <div style={style}>
      <Handle
        type="target"
        position="top"
        style={{ background: '#555' }}
        onConnect={(params) => console.log('handle onConnect', params)}
      />
      <img draggable={false} src={speaker} width='50' height='50'></img>

      <h4>{data.label}  </h4> 

      <Handle
        type="source"
        position="bottom"
        id="b2"
        style={{ bottom: -5, top: 'auto', background: '#555' }}
      />
    </div>
  );
});